import { render } from "./IconRefresh.vue?vue&type=template&id=48e2ffcf"
const script = {}

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconRefresh.vue"]])

export default __exports__